import React, { FC, ReactNode } from 'react'
import { Button, Dialog } from '../../ui'
import { DialogProps } from '../../ui/Dialog'

interface ConfirmationModalProps extends Omit<DialogProps, 'children'> {
	isOpen: boolean
	onClose: () => void
	onAction: () => void
	onCancel?: () => void
	icon?: ReactNode | null
	title?: string
	description?: ReactNode | string
	actionLabel?: string
	cancelLabel?: string
	cancelIcon?: ReactNode
	actionIcon?: ReactNode
	loading?: boolean
	cancelLoading?: boolean
	className?: string
	overlayClassName?: string
	cancelTooltip?: string
	closeAfterAction?: boolean
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
	isOpen,
	icon = null,
	onClose,
	onAction,
	onCancel,
	title = 'Confirmation',
	description = 'Are you sure?',
	cancelLabel = 'No',
	actionLabel = 'Yes',
	cancelIcon,
	actionIcon,
	loading = false,
	cancelLoading = false,
	className,
	overlayClassName,
	cancelTooltip = '',
	closeAfterAction = true,
	...dialogProps
}) => {
	const handleAction = async () => {
		await onAction()
		closeAfterAction && onClose()
	}

	if (!isOpen) return null
	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			icon={icon}
			className={className}
			overlayClassName={overlayClassName}
			controllers={
				<div className="flex items-center justify-end gap-2 w-full">
					<Button
						variant="tertiary"
						label={cancelLabel}
						onClick={onCancel ?? onClose}
						disabled={!!loading}
						loading={!loading && cancelLoading}
						leftIcon={cancelIcon}
						tooltip={cancelTooltip}
					/>
					<Button
						variant="primary"
						label={actionLabel}
						onClick={handleAction}
						disabled={!!cancelLoading}
						loading={!cancelLoading && loading}
						leftIcon={actionIcon}
					/>
				</div>
			}
			{...dialogProps}
		>
			<div className="text-text-main dark:text-text-main-dark text-wrap text-sm mb-4">
				{description}
			</div>
		</Dialog>
	)
}

export default ConfirmationModal
